import { getCookie } from 'utils/formatters';
import { deliveryMethodApi, DeliveryMethods } from '~constants/constants';

export interface IDeliveryMethodApiConfig {
    baseUrl: string;
}
export interface ISetDeliveryMethodRequest {
    deliveryMethod: string;
    storeId?: string;
}

export class DeliveryMethodsApiSdk {
    private readonly url: string;

    constructor(config: IDeliveryMethodApiConfig) {
        this.url = deliveryMethodApi;
    }

    public async setDeliveryMethod(params: ISetDeliveryMethodRequest) {
        const { deliveryMethod } = params;
        const reqUrl = this.url + this.getDeliveryMethodUrlPartial(deliveryMethod);
        await this.fetchJson(reqUrl, this.getReqBody(params));
    }

    private fetchJson = async (url: string, reqBody: string) => {
        try {
            const res = await fetch(url, {
                method: 'POST',
                body: `JSONRPC=${encodeURIComponent(reqBody)}`,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            });
            const json = await res.json();

            return json;
        } catch (err) {
            throw err;
        }
    };

    private getReqBody(reqParams: ISetDeliveryMethodRequest) {
        const { deliveryMethod: name, storeId: doorId } = reqParams;
        const mode = name === DeliveryMethods.STANDARD ? 'unset' : 'set';
        const args = {
            mode: mode,
            door_id: doorId || ''
        };

        return JSON.stringify([
            {
                method: this.getDeliveryMethodUrlPartial(name),
                params: [
                    {
                        method: 'post',
                        args: args,
                        _TOKEN: getCookie('csrftoken')
                    }
                ]
            }
        ]);
    }

    private getDeliveryMethodUrlPartial(methodName: string) {
        switch (methodName) {
            case DeliveryMethods.BOPIS:
                return 'bopis.select_bopis';
            case DeliveryMethods.COURIER:
                return 'courier.set_courier_ship_method';
            case DeliveryMethods.STANDARD:
                return 'bopis.select_bopis';
            default:
                return 'bopis.select_bopis';
        }
    }

    public async removeUnavailableItems(skus: number[]) {
        const reqUrl = `${this.url}rpc.form`;
        const params = JSON.stringify([
            {
                method: 'rpc.form',
                params: [
                    {
                        _SUBMIT: 'cart',
                        SKU_BASE_ID: skus,
                        INCREMENT: 0,
                        QTY: 0
                    }
                ]
            }
        ]);
        await this.fetchJson(reqUrl, params);
    }
}
